import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';

import type {
  ISelectableContainerInputDefinition,
  ISelectableContainerInputMapperProps,
} from '../types';
import { props as viewerPropsMapper } from './SelectableContainerInput.mapper';

const props = composeMapper<
  ISelectableContainerInputMapperProps,
  ISelectableContainerInputDefinition
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);

    return {
      ...viewerProps,
      previewWrapperProps: {
        compPreviewState: deps.compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({ props });
